import { Mappable } from '../../_shared/mappable.class';
import { Event } from './Event'
import { Cue5050 } from './Cue5050';
import { FundraisingSite } from './FundraisingSite';

export class Cue5050Site extends FundraisingSite  {

    cue5050SiteId: number;
    currentEvents: Cue5050[];
}
